import * as crmConstants from '../../constants/crm'
import { contactListConfUpdate } from '../../actions/crm'

const localStorage = window.localStorage


const saveToLocalStorage = (key, obj) => {
    const value = JSON.stringify(obj)
    localStorage.setItem(key, value)
}

const getFromLocalStorage = key => {
    const value = localStorage.getItem(key)
    return JSON.parse(value)
}

// save constact list config to local storage
const CRMLIST_VIEW_KEY = 'CALkulator CRM List View Conf'
export const CRMListView = ({ dispatch }) => next => action => {
    next(action)
    // save to local storage
    if (action.type === crmConstants.CRM_CONTACT_LIST_CONFIG_SAVE_TO_LOCAL_STORAGE) {
        saveToLocalStorage(CRMLIST_VIEW_KEY, action.payload)
    }
    // get from local storage
    if (action.type === crmConstants.CRM_CONTACT_LIST_CONFIG_GET_FROM_LOCAL_STORAGE) {
        const value = getFromLocalStorage(CRMLIST_VIEW_KEY)
        dispatch(contactListConfUpdate(value))
    }
}



export const localStorageMdl = [CRMListView]

